module.exports = __webpack_public_path__ + "static/media/nx.d4e0c212.jpg";